// extracted by mini-css-extract-plugin
module.exports = {"tourResale":"TourResale_tourResale__2ZK2V"};